import axios from 'axios'
import ConstList from './../ConstList'
import { requestFailureMessage } from '../utils/requestFailure'

/**
 * 申請・承認の失敗を、利用者が読める文言にする。
 *
 * この画面の catch は、失敗すると必ず GET /error/frontError/... を呼んでいた。
 * サーバにはPOSTしか無いのでその要求は404になり、内側の catch へ落ちて
 * 「システム通信エラーです。管理者に問い合わせてください。」が出る。
 * サーバが何を返しても同じ文言になり、原因も対処も伝わらない。
 *
 * 業務エラー（400・409）はサーバが利用者向けの文言を message に載せている。
 * それを出す。500と通信断だけ、従来どおりの案内にする。
 */
export function submissionErrorMessage (error) {
  // 決まりは全画面で同じにした（#615、2026-09-13）。中身は utils/requestFailure。
  return requestFailureMessage(error)
}

/**
 * 断られた理由を画面へ出す。500と通信断だけ、サーバへ記録を残す。
 *
 * <b>400番台はこちらの落ち度ではない。</b>権限が足りない・状態が合わない・
 * 必須が空、といった利用者が対処できる話なので、記録を溜めても読む人が
 * いない。理由をそのまま出すほうが早い。
 *
 * 500と通信断は今までどおり /error/frontError へ送る。ここを消すと、
 * 画面で起きた本物の異常が誰にも見えなくなる。
 */
export function alertSubmissionError (error) {
  const response = error && error.response ? error.response : null
  const status = response ? Number(response.status) : 0
  const message = submissionErrorMessage(error)

  if (status >= 400 && status < 500) {
    window.alert(message)
    return Promise.resolve()
  }

  return axios
    .post(
      `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
      { error: String(error) },
      { headers: { 'Content-Type': 'application/json' } }
    )
    .then(() => {
      window.alert(message)
    })
    .catch(() => {
      window.alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
    })
}
